{
  "jan": "Jan",
  "feb": "Feb",
  "mar": "Mar",
  "apr": "Apr",
  "may": "May",
  "jun": "Jun",
  "jul": "Jul",
  "aug": "Aug",
  "sep": "Sep",
  "oct": "Oct",
  "nov": "Nov",
  "dec": "Dec",
  "legendTitle": "Legend",
  "numberOfReports": "Number of reports",
  "total": "Total",
  "multipleAnswersWarning": "NB - Multiple options could be selected in a single report"
}
